import Link from "next/link";

import { css } from "@/../styled-system/css";
import Mail from "@/assets/svg/mail.svg";
import MapPin from "@/assets/svg/map-pin.svg";
import Phone from "@/assets/svg/phone.svg";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/Accordion";

const accordianTriggerCSS = {
  fontFamily: "inter",
  fontSize: "2xl",
  color: "gray.100",
  _expanded: {
    color: "white",
    boxShadow: "0 2px 0 #1CA9A5",
  },
  _hover: {
    boxShadow: "0 2px 0 #1CA9A5",
  },
  transition: "0.3s",
};

const footerLinkClass = css({
  fontFamily: "inter",
  fontSize: "md",
  fontWeight: "semibold",
  color: "gray.100",
});

const rowContainerClass = css({
  display: "flex",
  width: "100%",
  alignItems: "center",
  gap: "3.5",
  mb: "4",
  sm: {
    mb: "3",
  },
  "& .icon": {
    stroke: "brandTeal",
    flex: "none",
  },
  _first: {
    alignItems: "flex-start",
    verticalAlign: "top",
  },
});

const footerInfo = [
  {
    header: "Page",
    subhead: [
      { text: "Home", link: "/" },
      { text: "Catalog", link: "/catalog" },
      { text: "Profile", link: "/profile" },
    ],
  },
  // {
  //   header: "Support",
  //   subhead: [
  //     { text: "Teams", link: "/shop" },
  //     { text: "Career", link: "/contact-us" },
  //     { text: "Features", link: "/blog" },
  //     { text: "Benefits", link: "/about-us" },
  //   ],
  // },
  {
    header: "FAQ",
    subhead: [
      { text: "About Us", link: "/about-us" },
      { text: "Orders", link: "/orders" },
      { text: "Returns", link: "/faqs" },
      { text: "Contact Us", link: "/faqs#contact-us" },
    ],
  },
];

const contactInfo = [
  {
    text: "1 Broadway Cambridge, MA 02139 United States",
    icon: <MapPin className="icon" width="1.5rem" />,
  },
  {
    text: "support@solecit.co",
    icon: <Mail className="icon" width="1.5rem" />,
  },
  {
    text: "+01 816-301-4102",
    icon: <Phone className="icon" width="1.5rem" />,
  },
];

function FooterAccordion() {
  return (
    <Accordion
      className={css({
        borderColor: "neutral.300",
        display: "block",
        sm: { display: "none" },
      })}
      type="multiple"
    >
      {footerInfo.map((section, index) => (
        <AccordionItem
          key={index}
          value={`footer-tab-${index}`}
          css={{
            borderColor: "white",
          }}
        >
          <AccordionTrigger css={accordianTriggerCSS} strokeColor="white">
            {section.header}
          </AccordionTrigger>
          <AccordionContent>
            <div className={css({ display: "block" })}>
              {section.subhead.map((subhead, subheadIndex) => (
                <div key={subheadIndex} className={css({ mb: "4" })}>
                  <Link
                    href={subhead.link}
                    key={subheadIndex}
                    className={footerLinkClass}
                    prefetch
                  >
                    {subhead.text}
                  </Link>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
      <AccordionItem
        value={`footer-tab-3`}
        css={{
          borderColor: "white",
        }}
      >
        <AccordionTrigger css={accordianTriggerCSS} strokeColor="white">
          Contact Info
        </AccordionTrigger>
        <AccordionContent>
          <div className={css({ display: "block", wordBreak: "break-word" })}>
            {contactInfo.map((contact, index) => (
              <div key={index} className={rowContainerClass}>
                {contact.icon}
                <span className={css({ fontSize: "md", color: "gray.200" })}>
                  {contact.text}
                </span>
              </div>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default FooterAccordion;
